import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CompaniesState, Company } from './types'

const initialState: CompaniesState = {
  list: [],
  loading: false,
}

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    setCompanies(state, action: PayloadAction<Company[]>) {
      state.list = action.payload
      state.loading = false
    },
    setCompaniesLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
  },
})

export default companiesSlice.reducer

export const { setCompanies, setCompaniesLoading } = companiesSlice.actions
